<a [ngClass]="{'thin': thin}" [routerLink]="routerLink"><ng-content></ng-content></a>
